//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PERC',
  data() {
    return {
      defaultJson: {
        "Hemoptysis": "咯血",
        "Hypoxemia": "低氧血症",
        "LowPE_hint": "基于临床经验性评估（使用“Gestalt”或某个临床评分）,PE 可能性小于15%。",
        "O₂ Saturation < 95%": "氧饱和度<95%（呼吸空气）",
        "Exogenous Estrogen": "使用外源性雌激素",
        "Low Probability for PE": "PE可能性低",
        "Probability of PE < 2%": "PE 可能性 < 2%",
        "Prior History of DVT or PE": "既往 DVT 或 PE 病史",
        "PE cannot be ruled out": "PE 不能排除",
        "The rule does not apply": "本规则不适用",
        "Age ≥ 50 yr": "年龄≥50岁",
        "Recent Trauma or Surgery": "4周内有手术或创伤史",
        "PE ruled out": "PE 可排除",
        "Tachycardia": "心动过速",
        "Heart Rate ≥ 100 bpm": "心率≥100次/min",
        "Unilateral leg swelling": "单侧下肢肿胀"
      },
      form: {
        low_prob: '0',
        age: '0',
        hr: '0',
        o2: '0',
        history: '0',
        trauma: '0',
        hemoptysis: '0',
        estro: '0',
        swelling: '0',
      },
      hasScore: false,
      disabled: false,
      Multifocal_Candida_Colonization_hint: "Candida is simultaneously isolated from various noncontagious foci:\n\nfeces\/rectal swabs or\nurine or\nrespiratory or\nskin or\noropharynx\/stomach",
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        //  low_prob ? (age + hr + o2 + history + trauma + hemoptysis + estro + swelling):	1
        let result = form.low_prob ? (form.age + form.hr + form.o2 + form.history + form.trauma + form.hemoptysis + form.estro + form.swelling) : 1

        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/PERC.vue